import { TooltipProps } from 'recharts';
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';

type CustomTooltipProps = TooltipProps<ValueType, NameType> & {
  labelText?: string;
};

export const CustomTooltip = ({ active, payload, label, labelText = "Valor" }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const valor = payload[0].value as number;
    return (
      <div style={{
        background: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        borderRadius: '5px'
      }}>
        <strong>{label}</strong>
        <br />
        {labelText}: <span style={{ color: "#15325C" }}>R$ {valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
      </div>
    );
  }

  return null;
};
